import HeroBackground from './HeroBackground'
import './Hero.css'

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-background-pattern"></div>
      <HeroBackground />
      <div className="hero-content">
        <div className="container">
          <div className="hero-badge-row">
            <span className="hero-badge">Premium SaaS Studio &nbsp;·&nbsp; India</span>
          </div>

          <div className="hero-logo-section">
            <div className="hero-logo">
              <img src="/logo-1.png" alt="Janacode" className="hero-logo-img" />
            </div>
            <p className="logo-tagline">India's Code, Everyone's Product.</p>
          </div>
          
          <h1 className="hero-title">
            India's Code, <span className="highlight-orange">Everyone's Product.</span>
          </h1>
          
          <p className="hero-tagline">
            We build premium SaaS products across Sports Tech, Gaming, Finance, 
            Entertainment, Lifestyle & Marketing — engineered for scale, designed for the masses.
          </p>

          <div className="hero-cta">
            <button className="btn-primary" onClick={() => {
              const servicesSection = document.getElementById('sectors')
              servicesSection?.scrollIntoView({ behavior: 'smooth' })
            }}>
              Explore Our Sectors
            </button>
            <button className="btn-secondary" onClick={() => {
              const aboutSection = document.getElementById('about')
              aboutSection?.scrollIntoView({ behavior: 'smooth' })
            }}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
